"use strict";

define('uikit/mixins/injector.mixin',['underscore', 'backbone', 'marionette', '../channel'], function (_, Backbone, Mn, channel) {
  document.createElement('ui');
  var InjectorMixin = {
    componentSelector: 'ui',
    channel: channel,
    internalViews: null,
    getInternalViews: function getInternalViews() {
      return this._internalViews || [];
    },
    getInternalView: function getInternalView(name) {
      var internalView = Mn._getValue(this.getOption('internalViews'), this);
      return (internalView || {})[name];
    },
    internalViewOptions: null,
    getInternalViewOptions: function getInternalViewOptions(name) {
      var internalViewOptions = Mn._getValue(this.getOption('internalViewOptions'), this);
      return Mn._getValue((internalViewOptions || {})[name], this, [name]);
    },
    internalViewBindings: null,
    getInternalViewBindings: function getInternalViewBindings(name) {
      var internalViewBindings = Mn._getValue(this.getOption('internalViewBindings'), this);
      return (internalViewBindings || {})[name];
    },
    initialize: function initialize() {
      this._internalViews = (this._internalViews || []).slice();
      if (!_.isFunction(this.internalViews)) {
        this.internalViews = _.extend({}, this.internalViews);
      }
      this._injectorInitialExtractComponents();
      this.listenToOnce(this, 'before:destroy', this._onInjectorBeforeDestroy);
      this.listenTo(this, 'before:render', this._onInjectorBeforeRender);
      this.listenTo(this, 'render', this._onInjectorRender);
      this.listenTo(this, 'show', this._onInjectorShow);
    },
    _onInjectorBeforeDestroy: function _onInjectorBeforeDestroy() {
      this._injectorDestroyInternalViews();
    },
    _onInjectorBeforeRender: function _onInjectorBeforeRender() {
      if (this._isRendered) {
        _.each(this.getInternalViews(), function (viewName) {
          var view = this[viewName];
          if (view && view instanceof Backbone.View) {
            view.$el.detach();
          }
        }, this);
      }
    },
    _onInjectorRender: function _onInjectorRender() {
      this._injectorExtractComponents(this.el);
      if (this._hasSetupComponent) {
        this._injectorUpdateInternalViews();
      }
    },
    _onInjectorShow: function _onInjectorShow() {
      _.each(this.getInternalViews(), function (viewName) {
        var view = this[viewName];
        if (view && view instanceof Backbone.View) {
          Mn.triggerMethodOn(view, 'show');
        }
      }, this);
    },
    _injectorInitialExtractComponents: function _injectorInitialExtractComponents() {
      var template = this.getTemplate();
      if (template) {
        try {
          var div = document.createElement('div'),
            html = Mn.Renderer.render(template, this.serializeData(), this);
          div.innerHTML = html;
          this._injectorExtractComponents(div);
        } catch (e) {
          console.log(e);
        }
      }
    },
    _injectorExtractComponents: function _injectorExtractComponents(el) {
      var elements = [];
      elements = el.getElementsByTagName(this.componentSelector);
      this._injectorSetupComponents(elements);
    },
    _injectorDestroyInternalViews: function _injectorDestroyInternalViews() {
      _.each(this.getInternalViews(), function (viewName) {
        var view = this[viewName];
        if (view && view instanceof Mn.View) {
          view.destroy();
        }
      }, this);
    },
    _injectorUpdateInternalViews: function _injectorUpdateInternalViews() {
      var placeholders = [],
        placeholderEl = null,
        internalViews = this.getInternalViews();
      for (var i = 0, numOfInternalViews = internalViews.length; i < numOfInternalViews; i++) {
        placeholderEl = this.$(this.componentSelector + '[name="' + internalViews[i] + '"]');
        placeholders.push(placeholderEl);
      }
      for (var j = 0, numOfInternalViews = internalViews.length; j < numOfInternalViews; j++) {
        var view = this[internalViews[j]],
          didInject = false;
        if (!(view instanceof Backbone.View)) {
          continue;
        }
        if (!view._isRendered) {
          view.render();
        }
        if (this._isShown && view._shouldCallShow) {
          Mn.triggerMethodOn(view, 'before:show');
        }
        didInject = this._injectInternalView(view, placeholders[j]);
        if (this._isShown && view._shouldCallShow && didInject) {
          Mn.triggerMethodOn(view, 'show');
          delete view._shouldCallShow;
        }
      }
    },
    _injectInternalView: function _injectInternalView(view, placeholderEl) {
      if (placeholderEl.length > 0) {
        placeholderEl.replaceWith(view.$el);
        return true;
      } else {
        return false;
      }
    },
    _injectorSetupComponents: function _injectorSetupComponents(elements) {
      var length = elements.length,
        node = null,
        options = null,
        view = null;
      for (var n = 0; n < length; n++) {
        node = elements[n];
        options = this._injectorExtractElementOptions(node);
        options = _.extend({}, options, this.getInternalViewOptions(options.name));
        this._injectorStoreInternalViewReference(options.name);
        if (!this._injectorCanBuildComponent(options)) {
          continue;
        }
        view = this._injectorBuildComponent(options);
        if (view) {
          this._injectorSetupInternalViewBindings(options.name, view);
          this._injectorStoreComponentReference(options.name, view);
          this.once('destroy', view.destroy, view);
        }
      }
    },
    _injectorBuildComponent: function _injectorBuildComponent(options) {
      var Component = null;
      if (options.type) {
        Component = this.getComponentByType(options.type);
        delete options.type;
      } else {
        Component = this.getInternalView(options.name);
      }
      if (Component) {
        options = this._injectorMapComponentOptions(options, Component);
        return new Component(options);
      }
    },
    _injectorMapComponentOptions: function _injectorMapComponentOptions(options, component) {
      var nameMap = {
          tagname: 'tagName',
          classname: 'className'
        },
        mapped = {},
        self = this;
      _.each(component.prototype.options || {}, function (value, key) {
        nameMap[key.toLowerCase()] = key;
      });
      _.each(options, function (value, key) {
        mapped[nameMap[key] || key] = self.parseAttributeValue(value, key);
      });
      return mapped;
    },
    _injectorExtractElementOptions: function _injectorExtractElementOptions(node) {
      var attributes = node.attributes,
        len = attributes.length,
        attr = null,
        attrName = null,
        options = {};
      for (var a = 0; a < len; a++) {
        attr = node.attributes.item(a);
        attrName = attr.name.toLowerCase();
        options[attrName] = this.parseAttributeValue(attr.value, attrName);
      }
      return options;
    },
    _injectorCanBuildComponent: function _injectorCanBuildComponent(options) {
      var view = this[options.name];
      return options.name && !(view && view instanceof Backbone.View);
    },
    _injectorStoreComponentReference: function _injectorStoreComponentReference(name, view) {
      this[name] = view;
      this.triggerMethod('injected', view);
      this.triggerMethod('injected:' + name, view);
    },
    _injectorStoreInternalViewReference: function _injectorStoreInternalViewReference(name) {
      var internalViews = this._internalViews;
      if (name && internalViews.indexOf(name) == -1) {
        this._internalViews = internalViews.slice();
        this._internalViews.push(name);
      }
    },
    parseAttributeValue: function parseAttributeValue(value, name) {
      if (value === 'true') {
        value = true;
      } else if (value === 'false') {
        value = false;
      }
      return value;
    },
    getComponentByType: function getComponentByType(type) {
      return this.channel.request(String(type || ''));
    },
    _injectorSetupInternalViewBindings: function _injectorSetupInternalViewBindings(name, childview) {
      var bindings = this.getInternalViewBindings(name);
      if (bindings) {
        this._injectorBindInternalView(childview, bindings);
      }
      return this;
    },
    _injectorBindInternalView: function _injectorBindInternalView(childView, bindings) {
      var ev = _.extend({}, Backbone.Events),
        self = this;
      this._injectorUnbindInternalView(childView);
      ev.listenTo(this, 'before:destroy', function () {
        ev.stopListening();
      }).listenTo(childView, 'before:destroy', function () {
        ev.stopListening();
      });
      _.each(bindings, function (viewField, cvField) {
        childView[cvField] = self.getOption(viewField);
        ev.listenTo(self, 'change:' + viewField, function (self, value) {
          childView[cvField] = value;
        }).listenTo(childView, 'change:' + cvField, function (childView, value) {
          self[viewField] = value;
        });
      });
      this._injectorCacheInternalViewBinding(childView, ev);
    },
    _injectorUnbindInternalView: function _injectorUnbindInternalView(cv) {
      var existing = this._internalViewBindings || {},
        oldEvent = existing[cv.cid];
      if (oldEvent) {
        oldEvent.stopListening();
      }
    },
    _injectorCacheInternalViewBinding: function _injectorCacheInternalViewBinding(cv, ev) {
      this._internalViewBindings = this._internalViewBindings || {};
      this._internalViewBindings[cv.cid] = ev;
    }
  };
  return InjectorMixin;
});

